$(document).ready(function() {
    const client = algoliasearch('S6M009OAXE','c07368ed9b44ad8f68c7602c9fdc77f8');
    const index = client.initIndex('shopify_products');
  	const typeOption = document.getElementById('pfpType')
    const typeTitle = document.getElementById('pfpTypeTitle')
  	const manufacturerOption = document.getElementById('pfpManufacturer')
    const manufacturerTitle = document.getElementById('pfpManufacturerTitle')
    const seriesOption = document.getElementById('pfpSeries')
    const seriesTitle = document.getElementById('pfpSeriesTitle')
    const modelOption = document.getElementById('pfpModel')
    const modelTitle = document.getElementById('pfpModelTitle')
    const collection = 'Parts Finder'
    const yOffset = -10; 

    let typeValue, manufacturerValue, seriesValue, modelValue
        

  const searchForProduct = () => {
    window.location.href = `/collections/${manufacturerValue.toLowerCase().replace(' ', '-')}-${modelValue.toLowerCase().replace(/\s+/g, '-').replace('.', '-')}`
  }

  const searchForModels = async () => {
    modelOption.classList.add('show')
    modelTitle.classList.add('show')
    modelTitle.scrollIntoView({behavior: 'smooth', block: 'center'});
    index.searchForFacetValues('named_tags.Model', '', {
      filters: `named_tags.Manufacturer:"${manufacturerValue}" AND named_tags.Type:"${typeValue}" AND named_tags.Manufacturer:"${manufacturerValue}" AND named_tags.Series:"${seriesValue}"`
    }).then((res) => {
      $(modelOption).empty();
        const {facetHits} = res
        facetHits.map((cat) => {
          var opt = document.createElement('a');
          opt.setAttribute('href', cat.value) 
          opt.classList.add('part-finder-option')
          opt.innerText = cat.value;
          opt.addEventListener('click',(e) => {
            e.preventDefault()
            modelValue = e.target.getAttribute('href')
            searchForProduct() 
          })
          modelOption.appendChild(opt)
        })
    })
  }
    
  const searchForSeries = async () => {
    seriesOption.classList.add('show')
    seriesTitle.classList.add('show')
    seriesTitle.scrollIntoView({behavior: 'smooth', block: 'center'});
    index.searchForFacetValues('named_tags.Series', '', {
      filters: `named_tags.Type:"${typeValue}" AND named_tags.Manufacturer:"${manufacturerValue}"`
    }).then((res) => {
      $(seriesOption).empty();
      const {facetHits} = res
        facetHits.map((cat) => {
          var opt = document.createElement('a');
          opt.setAttribute('href', cat.value) 
          opt.classList.add('part-finder-option')
          opt.innerText = cat.value;
          opt.addEventListener('click',(e) => {
            e.preventDefault()
            seriesValue = e.target.getAttribute('href')
            searchForModels() 
          })
          seriesOption.appendChild(opt)
        })
    })
  }
  
  const searchForManufacturer = () => {
      manufacturerOption.classList.add('show')
      manufacturerTitle.classList.add('show')
      manufacturerTitle.scrollIntoView({behavior: 'smooth', block: 'center'});
      index.searchForFacetValues('named_tags.Manufacturer', '', {
      filters: `named_tags.Type:"${typeValue}"`
    }).then((res) => {
        $(manufacturerOption).empty();
        const {facetHits} = res
        facetHits.map((cat) => {
          var opt = document.createElement('a');
          opt.setAttribute('href', cat.value) 
          opt.classList.add('part-finder-option')
          opt.innerText = cat.value;
          opt.addEventListener('click',(e) => {
            e.preventDefault()
            manufacturerValue = e.target.getAttribute('href')
            searchForSeries() 
          })
          manufacturerOption.appendChild(opt)
        })
      })
    }
  
      const searchForType = () => {
      index.searchForFacetValues('named_tags.Type', '').then((res) => {
        const {facetHits} = res
        facetHits.map((cat) => {
          var opt = document.createElement('a');
          opt.setAttribute('href', cat.value); 
          opt.classList.add('part-finder-option');
          opt.innerText = cat.value;
          opt.addEventListener('click',(e) => {
            e.preventDefault()
            typeValue = e.target.getAttribute('href')
            searchForManufacturer() 
          })
          typeOption.appendChild(opt)
        })
      })
    }



    if(typeOption) {
      searchForType()
    }
})

